<template>
  <div class="fair-survey-step fair-survey-step--centered">
    <div class="fair-survey-step__head fair-survey-step__head--centered">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <!-- Config writes the subtitle with literal newlines; keep them. -->
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle later-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TasteStep } from '@/features/taste/types/taste-config'

defineProps<{ step: TasteStep & { type: 'later' } }>()
</script>

<style scoped>
.fair-survey-step--centered {
  justify-content: center;
  align-items: center;
}

.later-step__subtitle {
  max-width: 480px;
  text-align: center;
  white-space: pre-line;
}
</style>
